'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('./svgFiltersParts'),
    hex2RgbNorm = _require.hex2RgbNorm,
    getAlpha = _require.getAlpha,
    getDoutone = _require.getDoutone,
    getColor = _require.getColor,
    getTint = _require.getTint,
    getLumaMatrix = _require.getLumaMatrix,
    getBrightness = _require.getBrightness,
    getSepia = _require.getSepia,
    getContrast = _require.getContrast;

var _ = function _(key, value) {
  return value || value === 0 ? key + "=\"" + value + "\"" : '';
};

var attrsToString = function attrsToString(attrs) {
  return Object.keys(attrs).map(function (key) {
    return _(key, attrs[key]);
  }).join(' ');
};

function filterWrapperTemplate(_ref) {
  var id = _ref.id,
      content = _ref.content,
      _ref$attrs = _ref.attrs,
      attrs = _ref$attrs === void 0 ? {} : _ref$attrs;
  // the redundant identity <feComponentTransfer/> in start and end
  // are for fixing old Webkit bug that caused it to ignore color-interpolation-filters="sRGB"
  return "<filter id=\"" + id + "\" color-interpolation-filters=\"sRGB\" " + attrsToString(attrs) + ">\n    <feComponentTransfer result=\"srcRGB\"/>\n    " + content + "\n    <feComponentTransfer/>\n</filter>";
}

function identity(_ref2) {
  var inAttr = _ref2.inAttr;
  return "<feColorMatrix " + _('in', inAttr) + "/>";
}

function contrast(_ref3) {
  var value = _ref3.value;
  return "<feComponentTransfer>" + getContrast(value) + "</feComponentTransfer>";
}

function brightness(_ref4) {
  var value = _ref4.value,
      result = _ref4.result;
  return "<feComponentTransfer " + _('result', result) + ">" + getBrightness(value) + "</feComponentTransfer>";
}
/**
 * @param {{value?: *, inAttr?: *, result?: *}} op
 * @returns {string}
 */


function saturation(_ref5) {
  var value = _ref5.value,
      inAttr = _ref5.inAttr,
      result = _ref5.result;
  return "<feColorMatrix type=\"saturate\" values=\"" + value + "\" " + _('in', inAttr) + " " + _('result', result) + "/>";
}

function sepia(_ref6) {
  var value = _ref6.value;
  return "<feColorMatrix type=\"matrix\" values=\"" + getSepia(value) + "\"/>";
}

function hue(_ref7) {
  var value = _ref7.value;
  return "<feColorMatrix type=\"hueRotate\" values=\"" + value + "\"/>";
}
/**
 * @param {{value?:*,inAttr?:*,result?:*}} op
 * @returns {string}
 */


function color(_ref8) {
  var value = _ref8.value,
      inAttr = _ref8.inAttr,
      result = _ref8.result;
  var hexColor = typeof value === 'string' ? value : value.color;
  var opacity = typeof value.opacity === 'undefined' ? 1 : value.opacity;
  return "<feColorMatrix type=\"matrix\" values=\"" + getColor(hex2RgbNorm(hexColor), opacity) + "\" " + _('in', inAttr) + " " + _('result', result) + "/>";
}

function tint(_ref9) {
  var value = _ref9.value;
  return "<feColorMatrix type=\"matrix\" values=\"" + getTint(hex2RgbNorm(value)) + "\"/>";
}

function blur(_ref10) {
  var value = _ref10.value,
      inAttr = _ref10.inAttr;
  return "<feGaussianBlur stdDeviation=\"" + value + "\" " + _('in', inAttr) + "/>";
}

function alpha(_ref11) {
  var value = _ref11.value,
      inAttr = _ref11.inAttr,
      result = _ref11.result;
  return "<feComponentTransfer " + _('in', inAttr) + " " + _('result', result) + ">" + getAlpha(value) + "</feComponentTransfer>";
}
/**
 * @param {{value?:*,inAttr?:*,result?:*}} op
 * @returns {string}
 */


function offset(_ref12) {
  var value = _ref12.value,
      inAttr = _ref12.inAttr,
      result = _ref12.result;
  return "<feOffset dx=\"" + value.x + "\" dy=\"" + value.y + "\" " + _('in', inAttr) + " " + _('result', result) + "/>";
}

function blend(_ref13) {
  var value = _ref13.value,
      inAttr = _ref13.inAttr,
      in2Attr = _ref13.in2Attr,
      result = _ref13.result;
  return "<feBlend mode=\"" + value + "\" in=\"" + inAttr + "\" in2=\"" + in2Attr + "\" " + _('result', result) + "/>";
}

function composite(_ref14) {
  var value = _ref14.value,
      inAttr = _ref14.inAttr,
      in2Attr = _ref14.in2Attr,
      result = _ref14.result;
  return "<feComposite operator=\"" + value + "\" in=\"" + inAttr + "\" in2=\"" + in2Attr + "\" " + _('result', result) + "/>";
}

function duotone(_ref15) {
  var _ref15$value = _ref15.value,
      dark = _ref15$value.dark,
      light = _ref15$value.light,
      inAttr = _ref15.inAttr,
      result = _ref15.result;
  return saturation({
    value: 0
  }) + "\n<feColorMatrix type=\"matrix\" values=\"" + getDoutone(hex2RgbNorm(light), hex2RgbNorm(dark)) + "\" " + _('in', inAttr) + " " + _('result', result) + "/>";
}

function luma(_ref16) {
  var _ref16$value = _ref16.value,
      dark = _ref16$value.dark,
      light = _ref16$value.light,
      result = _ref16.result;
  return "<feColorMatrix type=\"matrix\" values=\"" + getLumaMatrix(light, dark) + "\" " + _('result', result) + "/>";
}

function shadow(_ref17) {
  var _ref17$value = _ref17.value,
      x = _ref17$value.x,
      y = _ref17$value.y,
      blurRadius = _ref17$value.blurRadius,
      hexColor = _ref17$value.color,
      opacity = _ref17$value.opacity,
      _ref17$value$mergeGra = _ref17$value.mergeGraphic,
      mergeGraphic = _ref17$value$mergeGra === void 0 ? true : _ref17$value$mergeGra;
  return blur({
    value: blurRadius,
    inAttr: 'SourceAlpha'
  }) + "\n" + offset({
    value: {
      x: x,
      y: y
    }
  }) + "\n" + color({
    value: {
      color: hexColor,
      opacity: opacity
    }
  }) + "\n" + (mergeGraphic ? "<feMerge>\n    <feMergeNode/>\n    <feMergeNode in=\"SourceGraphic\"/>\n</feMerge>" : '');
}

var filterComponentTempaltes = {
  identity: identity,
  contrast: contrast,
  brightness: brightness,
  sepia: sepia,
  saturation: saturation,
  hue: hue,
  tint: tint,
  color: color,
  blur: blur,
  alpha: alpha,
  offset: offset,
  blend: blend,
  composite: composite,
  duotone: duotone,
  luma: luma,
  shadow: shadow
};

function getValue(key, value, overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (key === 'duotone') {
    return {
      light: overrides.duotoneLight || value.light,
      dark: overrides.duotoneDark || value.dark
    };
  } else if (key in overrides) {
    return overrides[key];
  }

  return value;
}
/**
 * Create a string of an SVG filter
 *
 * @param {string} id the value for the id attribute on the filter
 * @param {Object[]} filterDefinition list of filter effect descriptors
 * @param {Object} [overrides] properties to override the effect.value
 * @param {Object} [attrs] extra attributes to add to the <filter> tag
 * @return {string}
 */


function interpolate(id, filterDefinition, overrides, attrs) {
  var content = filterDefinition.map(function (effect) {
    var key = effect.key;
    var value = getValue(key, effect.value, overrides);
    return filterComponentTempaltes[key](_objectSpread(_objectSpread({}, effect), {}, {
      value: value
    }));
  }).join('\n');
  return filterWrapperTemplate({
    id: id,
    content: content,
    attrs: attrs
  });
}

function getProperties(filterDefinition, overrides) {
  return filterDefinition.map(function (effect) {
    var _ref18;

    var key = effect.key;
    var value = getValue(key, effect.value, overrides);
    return _ref18 = {}, _ref18[key] = value, _ref18;
  });
}
/**
 * @type {{interpolate:function, getProperties:function}}
 */


module.exports = {
  interpolate: interpolate,
  getProperties: getProperties
};
//# sourceMappingURL=svgFiltersTemplates.js.map